<template>
  <div v-if="deviceData !== null" v-loading="loading" class="container-list">
    <div v-for="item of deviceData.diagnostic_field" :key="item.id" class="container-list__item item">
      <div class="item__title">{{ item.title }}</div>
      <div class="item__value">{{
          findValue(item.id) && findValue(item.id).input ? findValue(item.id).input : '-'
        }}
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "HealthStation",
  data() {
    return {
      loading: false,
      diagnosticFieldValue: []
    }
  },
  props: {
    deviceData: {},
    editDeviceData: {},
  },
  created() {

  },
  computed: {
    ...mapGetters("visit", {device: "getDevices"}),
    ...mapGetters("session", {session: "session"}),
    visit() {
      return this.$route.params.visit
    },
  },
  methods: {
    ...mapActions({
      setVisit: "visit/SET_DATA",
    }),
    findValue(id) {
      return this.diagnosticFieldValue.find(item => item.diagnostic_field_id === id)
    },
    loadData() {
      this.loading = true
      this.$api.devices
          .device(this.session.id, this.deviceData.id)
          .then((response) => {

            this.diagnosticFieldValue = response.data
          })
          .catch((res) => {
            this.$notify.error({
              title: "Ошибка загрузки данных 😕",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
  watch: {
    deviceData() {
      this.loadData()
    },
    editDeviceData(value) {
      if (!value) this.loadData()
    },

  }

}

</script>

<style lang="scss" scoped>
.container-list {

}

.item {
  border-bottom: 1px solid #EAEAEA;
  padding: 13px 0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 14px;
  line-height: 22px;
  color: #111;

  &__value {
    color: #676767;

  }
}
</style>